export default "__VITE_ASSET__DzpxrNwb__"